// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"26":"01a94827","260":"2ba366f9","361":"11903593","384":"fcc1a402","886":"e4e571fd"}[chunkId] + ".css";
};